import '../javascripts/compat/polyfills'
import { mountFrontend } from '../javascripts/entrypoint/bootstrap'
import { shellComponents } from '../javascripts/entrypoint/shell_components'

mountFrontend({
  components: shellComponents,
})
